import { i18n } from '../../i18n/i18n';

export function formatRelativeTime(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return i18n.t('time.neverSeen');
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return i18n.t('time.neverSeen');

  // A heartbeat later than "now" isn't reliable evidence of anything —
  // don't render a misleading "in X minutes"-style future time.
  if (then > now) return i18n.t('time.neverSeen');

  const deltaSec = Math.floor((now - then) / 1000);
  if (deltaSec < 45) return i18n.t('time.justNow');
  if (deltaSec < 3600) return i18n.t('time.minutesAgo', { count: Math.floor(deltaSec / 60) });
  if (deltaSec < 86400) return i18n.t('time.hoursAgo', { count: Math.floor(deltaSec / 3600) });
  return i18n.t('time.daysAgo', { count: Math.floor(deltaSec / 86400) });
}
